var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 h-full overflow-auto bg-neutral-100"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }